import { h, Component, Fragment } from 'preact';

export default class ModalComponent extends Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const self = this;
        return (
            <Fragment>
                <div class={`modal ${self.props.isOpen ? '' : 'hidden'}`} onclick={() => self.props.close()}>
                    <div class="modal-foreground" onclick={e => e.stopPropagation()}>
                        <div class="description-modal">
                            <h5 class="modal-heading">{self.props.option.label}</h5>
                            <div>
                                {
                                    self.props.option.description?.map(x => {
                                        if (x.type === 'text') {
                                            return x.value;
                                        }
                                        else if (x.type === 'link') {
                                            return <a class="modala" rel="noreferrer" target="_blank" href={x.value}>{x.text}</a>;
                                        }
                                        return "";
                                    })
                                }
                            </div>
                        </div>
                        <div class="close-modal">
                            <button onclick={() => self.props.close()}>Close</button>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
